import React, { Component } from 'react';
import { object } from 'prop-types';
import { connect } from 'react-redux';

import NotificationsViews from './views';


class Notifications extends Component {
  render() {
    const { reader: { ebook } } = this.props;
    let rid = 'na';
    let reqId = 'na';
    if (ebook && ebook.rid && ebook.rid.split('-') && ebook.rid.split('-')[0]) {
      rid = ebook.rid.split('-')[0];
    }

    if (ebook && ebook.req_id && ebook.req_id.split('-') && ebook.req_id.split('-')[0]) {
      reqId = ebook.req_id.split('-')[0];
    }
    const accountType = ebook && ebook?.accountType;
    const viewProps = { rid, reqId, accountType };

    return <NotificationsViews { ...viewProps } />;
  }
}

NotificationsViews.propTypes = {
  reader: object
};


function mapStateToProps(state) {
  return {
    reader: state.reader
  };
}


export default connect(mapStateToProps)(Notifications);
